// dependencies import ==>
import React, { useState } from "react";
// assets and scss import ==>
import "./saveTemplateView.scss";
// project file import ==>
import FormInputWithHeader from "../../../common/FormInputWithHeader";

const SaveTemplateView = (props) => {
  const {
    templateError,
    isChecked,
    templateName,
    handleTemplateName,
    handleTemplateSave,
    handleTemplateCancel,
    handleOverrideTemplateYes,
    handleOverrideTemplateNo,
  } = props;

  const [inputError, setInputError] = useState(false);

  // Actions ==>
  const handleSave = () => {
    if (templateName?.trim()?.length > 0) {
      setInputError(false);
      handleTemplateSave();
    } else {
      setInputError(true);
    }
  };

  const handleCancel = () => {
    setInputError(false);
    handleTemplateCancel();
  };

  const displaySaveTemplateView = () => {
    const isTemplateNameBlank = templateName?.trim().length === 0;

    return (
      <div>
        <div className="save-template-wrapper">
          <div
            className={
              "save-template-override-wrapper " +
              (templateError ? "template-override-error" : "")
            }
          >
            <FormInputWithHeader
              type="text"
              placeholder="Template Name"
              maxLimit={250}
              value={templateName}
              disabled={templateError}
              handleOnChangeInput={handleTemplateName}
            />
            <div className="save-template-error-wrapper">
              {isChecked && inputError && (
                <div className="save-template-error">Enter Template Name</div>
              )}

              {templateError ? (
                <>
                  <div
                    className="save-template-cancel-btn"
                    onClick={handleOverrideTemplateNo}
                  >
                    No
                  </div>
                  <div
                    className="save-template-save-btn-yes"
                    onClick={handleOverrideTemplateYes}
                  >
                    Yes
                  </div>
                </>
              ) : (
                <div className="save-template-save-cancel-btn-wrapper">
                  <div
                    className="save-template-cancel-btn"
                    onClick={handleCancel}
                  >
                    Cancel
                  </div>
                  <div
                    className={`save-template-save-btn ${
                      isTemplateNameBlank ? "disabled" : ""
                    }`}
                    onClick={handleSave}
                    disabled={isTemplateNameBlank}
                  >
                    Save
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {templateError && (
          <div className="save-template-error">
            The template already exists. Would you like to override?
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="save-template-view-container">
      {displaySaveTemplateView()}
    </div>
  );
};

export default SaveTemplateView;
